//
//
//
//
//
//
//
//
//
//
//
//

import querystring from "@/js/querystring";
import { SUCCESS_CODE } from "@/service/httpCode";
import { setStorage, getStorage } from "@/js/utils";
import { ignoreRoute } from "@/config";

export default {
    name: "app",
    data() {
        return {
            hasHeader: true,
            title: document.title,
            // compCache: ['bindcard', 'repay', 'loanbindcard', 'creditCardAdd']
        };
    },
    watch: {
        $route: {
            async handler() {
                this.title = document.title;
            },
            immediate: true,
        },
    },
    async created() {
        const {
            secret,
            orderNo,
            appId,
            userId,
            bizCode,
            orderType,
            businessID,
            sg,
        } = querystring.parse() || {};
        if (!ignoreRoute.includes(location.pathname)) {
            if (sg) {
                // 签约回调特殊处理
                try {
                    const sgValue = decodeURIComponent(sg);
                    const queryParams =
                        typeof sgValue == "string"
                            ? JSON.parse(sgValue)
                            : sgValue;

                    const storeInfoInStorage =
                        getStorage("session", "storeInfo") || {};

                    Object.assign(this.$store, storeInfoInStorage);

                    this.$router.replace({
                        name: location.pathname.substring(1),
                        query: queryParams,
                    });
                } catch (e) {
                    console.log(e);
                }
            } else if (orderNo) {
                const storeInfoInStorage =
                    getStorage("session", "storeInfo") || {};
                const info =
                    storeInfoInStorage.orderNo === orderNo
                        ? storeInfoInStorage
                        : {
                            orderNo,
                            appId,
                            userId,
                            bizCode,
                            orderType,
                            businessID,
                        };
                Object.assign(this.$store, info);
                setStorage("session", "storeInfo", info);
            } else {
                const { data, result } = await this.$http.validateToken({
                    token: encodeURIComponent(secret),
                });
                if (result === SUCCESS_CODE) {
                    const {
                        orderType,
                        orderNo,
                        appId,
                        userId,
                        bizCode,
                        businessID,
                    } = data;
                    Object.assign(this.$store, {
                        orderType,
                        orderNo,
                        appId,
                        userId,
                        bizCode,
                        businessID,
                    });
                    setStorage("session", "storeInfo", this.$store);
                    let routeName = "";
                    if ([1, 2, 6, 9, 20].includes(orderType)) {
                        routeName = "bindcard";
                    }
                    if ([4, 8].includes(orderType)) {
                        routeName = "repay";
                    }
                    if (orderType === 14) {
                        routeName = "recordList";
                    }
                    if (orderType === 15) {
                        routeName = "prephone";
                    }
                    if (orderType === 16) {
                        routeName = "loanBindCard";
                    }
                    if (orderType === 17) {
                        routeName = "pay";
                    }
                    if (orderType === 18) {
                        routeName = "offlineRepayMore";
                    }
                    if (orderType === 19) {
                        routeName = "loanBindCardNew";
                    }
                    this.$router.replace({
                        name: routeName,
                        query: {
                            orderNo,
                            appId,
                            userId,
                            bizCode,
                            orderType,
                            businessID,
                        },
                    });
                }
            }
        }
        this.$bus.$on(
            "update-title",
            ({ hasHeader, title, noClose, rightView }) => {
                if (hasHeader !== undefined) {
                    this.hasHeader = hasHeader;
                }
                if (title !== undefined) {
                    document.title = title;
                    this.title = title;
                    // 借款app或理财app
                    if (
                        window.PPDWebUI &&
                        window.PPDWebUI.os.inApp &&
                        ["PPDLendApp", "PPDLoanApp"].includes(
                            window.PPDWebUI.os.channel
                        )
                    ) {
                        let navParams = {
                            visible: "1",
                            fullScreen: "2",
                            leftView: [
                                {
                                    action: "back",
                                    icon: "ppdwebui://resource/drawable/nav_back",
                                },
                            ],
                            titleView: {
                                text: title,
                            },
                        };
                        if (!noClose) {
                            navParams.leftView.push({
                                action: "close",
                                icon: "ppdwebui://resource/drawable/nav_close",
                            });
                        }
                        if (rightView) {
                            navParams.rightView = rightView;
                        }
                        window.PPDWebUI.CommonService.setNavigation(
                            navParams,
                            function () { },
                            function (err) { }
                        );
                    }
                }
            }
        );

        this.$bus.$on("header-control", ({ hasHeader, title }) => {
            this.title = title;
            this.hasHeader = hasHeader;
        });
    },
    destroyed() {
        this.$bus.$off(["update-title"]);
        this.$bus.$off(["header-control"]);
    },
};
